import axios from "@/config/axios"

const initiateState = () => {
  return {
    allIcd10Codes: {},
    allCptCodes: {},
    addIcd10CodeStatus: null,
  }
}
const state = initiateState()
const getters = {
  getAllIcd10Codes: (state) => state.allIcd10Codes,
  getAllCptCodes: (state) => state.allCptCodes,
  getAddIcd10CodeStatus: (state) => state.addIcd10CodeStatus,
}
const mutations = {
  setAllIcd10Codes(state, data) {
    state.allIcd10Codes = data
  },
  setAddIcd10CodeStatus(state, data) {
    state.addIcd10CodeStatus = data
  },
  setAllCptCodes(state, data) {
    state.allCptCodes = data
  },
  reset: (state) => {
    const initial = initiateState()
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key]
    })
  },
}
const actions = {
  addIcd10Code: async ({ commit, dispatch }, params) => {
    try {
      await dispatch("errors/clear", [], { root: true })
      commit("setAddIcd10CodeStatus", null)
      const response = await axios.post("icd-10-codes", params)
      commit("setAddIcd10CodeStatus", response.data)
    } catch (error) {
      const errorPayload =
        error?.response?.data || {
          success: false,
          message: "Failed to add ICD-10 code",
        }
      commit("setAddIcd10CodeStatus", errorPayload)
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true })
      }
    }
  },
  fetAllIcd10Codes: async ({ commit, dispatch }, params) => {
    try {
      await dispatch("errors/clear", [], { root: true })

      const response = await axios.get("icd-10-codes", { params })

      commit("setAllIcd10Codes", response.data)
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, {
          root: true,
        })
      }
    }
  },
  fetAllCptCodes: async ({ commit, dispatch }, params) => {
    try {
      await dispatch("errors/clear", [], { root: true })

      const response = await axios.get("cpt-codes", { params })

      commit("setAllCptCodes", response.data)
    } catch (error) {
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, {
          root: true,
        })
      }
    }
  },
}
export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
}
